import styled from '@emotion/styled'
import React from 'react'
import { color, font, size, space } from '../../styles'

const Links: { label: string; url: string }[] = [
   { label: 'Privacy Policy', url: 'https://rentpost.com/legal/privacy' },
   { label: 'Terms & Conditions', url: 'https://rentpost.com/legal/tac' },
   { label: 'Data Protection Policy', url: 'https://rentpost.com/legal/data-protection' },
]

const FooterLinks: React.FC = () => {
   return (
      <Holder>
         <div className="footer-links">
            {Links.map((link) => (
               <a href={link.url} key={link.label}>
                  {link.label}
               </a>
            ))}
         </div>
      </Holder>
   )
}

const Holder = styled.div`
   margin: 0;
   padding: 0;
   line-height: 1.05;
   a {
      ${font.thin};
      font-size: ${size.xs};
      color: ${color.grayDark};
      text-decoration: none;
      padding-inline: ${space.xs};

      &:not(:last-child):after {
         content: '|';
         position: relative;
         left: 0.5em;
      }

      &:hover {
         color: #000000b6;
      }
   }
`
export default FooterLinks
